const getBaseUrl = () => {
  const env = localStorage.getItem("api_env") || "development";
  return env === "development"
    ? process.env.REACT_APP_DEV_BASE_URL
    : process.env.REACT_APP_PRD_BASE_URL;
};

function toBase64(str) {
  return btoa(unescape(encodeURIComponent(str)));
}

function generarBasicAuth() {
    const usuario = "a_45_12@@_chachitoo3000";
    const contraseña = "el_jj_44_?¿_sinopaque_$/$"; 
    const credenciales = `${usuario}:${contraseña}`;
    const base64 = toBase64(credenciales); // Codifica en Base64
    return `Basic ${base64}`;
}

const API = {
    /** USERS */
    postLogin : async(requestBody) =>{
        try{
            const body = JSON.stringify(requestBody)
            const response = await fetch(`${getBaseUrl()}/user/login`, {
                    method: "POST",
                    headers: {
                        "Accept": "application/json",
                        "Content-Type": "application/json",
                        'Authorization': generarBasicAuth()
                    },
                    body: body
                }
            )
            const json = await response.json()

            return { data: json.data, status: response.status, message: json.message }

        }catch(error){
            return { data: null, status: 400, message: error.message }
        }
    },

    postUser : async(requestBody) =>{
        try{
            const body = JSON.stringify(requestBody)
            const response = await fetch(`${getBaseUrl()}/user/parent`, {
                    method: "POST",
                    headers: {
                        "Accept": "application/json",
                        "Content-Type": "application/json",
                        'Authorization': generarBasicAuth()
                    },
                    body: body
                }
            )
            const json = await response.json()

            return {data: json.data, status: response.status, message: json.message}

        }catch(error){
            return {data: null, status: 400, message: error.message}
        }
    },
    patchUser : async(requestBody) =>{
        try{
            const body = JSON.stringify(requestBody)
            const response = await fetch(`${getBaseUrl()}/user/parent`, {
                    method: "PATCH",
                    headers: {
                        "Accept": "application/json",
                        "Content-Type": "application/json",
                        'Authorization': generarBasicAuth()
                    },
                    body: body
                }
            )
            const json = await response.json()

            return {data: json.data, status: response.status, message: json.message}

        }catch(error){
            return {data: null, status: 400, message: error.message}
        }
    },
    deleteUser: async(queryParams)=>{
        try{
            const params = new URLSearchParams(queryParams).toString()
            
            const response = await fetch(`${getBaseUrl()}/user/parent?`+params, {
                    method: "DELETE",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        'Authorization': generarBasicAuth()
                    },
                }
            )
            const json = await response.json()

            return {data: json.data, status: response.status, message: json.message}

        }catch(error){
            return {data: null, status: 400, message: "Ha habido un error"}
        }
    },

    /** SON */
    getSon : async(queryParams) =>{
        try{
            const params = new URLSearchParams(queryParams).toString()
            
            const response = await fetch(`${getBaseUrl()}/user/son?`+params, {
                    method: "GET",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        'Authorization': generarBasicAuth()
                    },
                }
            )
            const json = await response.json()

            return {data: json.data, status: response.status, message: json.message}

        }catch(error){
            return {data: null, status: 400, message: "Ha habido un error"}
        }
    },
    postSon : async(requestBody) =>{
        try{
            const body = JSON.stringify(requestBody)
            const response = await fetch(`${getBaseUrl()}/user/son`, {
                    method: "POST",
                    headers: {
                        "Accept": "application/json",
                        "Content-Type": "application/json",
                        'Authorization': generarBasicAuth()
                    },
                    body: body
                }
            )
            const json = await response.json()

            return {data: json.data, status: response.status, message: json.message}

        }catch(error){
            return {data: null, status: 400, message: error.message}
        }
    },
    patchSon : async(requestBody) =>{
        try{
            const body = JSON.stringify(requestBody)
            const response = await fetch(`${getBaseUrl()}/user/son`, {
                    method: "PATCH",
                    headers: {
                        "Accept": "application/json",
                        "Content-Type": "application/json",
                        'Authorization': generarBasicAuth()
                    },
                    body: body
                }
            )
            const json = await response.json()

            return {data: json.data, status: response.status, message: json.message}

        }catch(error){
            return {data: null, status: 400, message: error.message}
        }
    },
    deleteSon : async(queryParams) =>{
        try{
            const params = new URLSearchParams(queryParams).toString()
            
            const response = await fetch(`${getBaseUrl()}/user/son?`+params, {
                    method: "DELETE",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        'Authorization': generarBasicAuth()
                    },
                }
            )
            const json = await response.json()

            return {data: json.data, status: response.status, message: json.message}

        }catch(error){
            return {data: null, status: 400, message: "Ha habido un error"}
        }
    },
    

     /** CARDEX */
    getCardex : async(queryParams) =>{
        try{
            const params = new URLSearchParams(queryParams).toString()
            
            const response = await fetch(`${getBaseUrl()}/user/cardex?`+params, {
                    method: "GET",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        'Authorization': generarBasicAuth()
                    },
                }
            )
            const json = await response.json()

            return {data: json.data, status: response.status, message: json.message}

        }catch(error){
            return {data: null, status: 400, message: "Ha habido un error"}
        }
    },
    postCardex : async(requestBody) =>{
        try{
            const body = JSON.stringify(requestBody)
            const response = await fetch(`${getBaseUrl()}/user/cardex`, {
                    method: "POST",
                    headers: {
                        "Accept": "application/json",
                        "Content-Type": "application/json",
                        'Authorization': generarBasicAuth()
                    },
                    body: body
                }
            )
            const json = await response.json()

            return {data: json.data, status: response.status, message: json.message}

        }catch(error){
            return {data: null, status: 400, message: error.message}
        }
    },
    patchCardex: async(requestBody) =>{
        try{
            const body = JSON.stringify(requestBody)
            const response = await fetch(`${getBaseUrl()}/user/cardex`, {
                    method: "PATCH",
                    headers: {
                        "Accept": "application/json",
                        "Content-Type": "application/json",
                        'Authorization': generarBasicAuth()
                    },
                    body: body
                }
            )
            const json = await response.json()

            return {data: json.data, status: response.status, message: json.message}

        }catch(error){
            return {data: null, status: 400, message: error.message}
        }
    },
    deleteCardex: async(queryParams) =>{
        try{
            const params = new URLSearchParams(queryParams).toString()
            
            const response = await fetch(`${getBaseUrl()}/user/cardex?`+params, {
                    method: "DELETE",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        'Authorization': generarBasicAuth()
                    },
                }
            )
            const json = await response.json()

            return {data: json.data, status: response.status, message: json.message}

        }catch(error){
            return {data: null, status: 400, message: "Ha habido un error"}
        }
    },

    /*PASSWORD */
    patchPassword : async(requestBody) =>{
        try{
            const body = JSON.stringify(requestBody)
            const response = await fetch(`${getBaseUrl()}/user/password`, {
                    method: "PATCH",
                    headers: {
                        "Accept": "application/json",
                        "Content-Type": "application/json",
                        'Authorization': generarBasicAuth()
                    },
                    body: body
                }
            )
            const json = await response.json()

            return {data: json.data, status: response.status, message: json.message}

        }catch(error){
            return {data: null, status: 400, message: error.message}
        }
    },

     /**MEDIA SYSTEM */
    postMedia : async(image, queryParams) =>{
        try{

            const params = new URLSearchParams(queryParams).toString()
            const response = await fetch(`${getBaseUrl()}/media?`+params, {
                    method: "POST",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": image != null ? image.type : "image/png",
                        'Authorization': generarBasicAuth()
                    },
                    body: image,
                }
            )
            const json = await response.json()

            return {data: json.data, status: response.status, message: json.message}

        }catch(error){
            return {data: null, status: 400, message: error.message}
        }
    },

    /*BANNERS */
    getBanners: async(queryParams) =>{
        try{
            const params = new URLSearchParams(queryParams).toString()
            const response = await fetch(`${getBaseUrl()}/banners?`+params, {
                    method: "GET",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        'Authorization': generarBasicAuth()
                    },
                }
            )
            const json = await response.json()

            return {data: json.data, status: response.status, message: json.message}

        }catch(error){
            return {data: null, status: 400, message: "Ha habido un error"}
        }
    },

    
}

export default API;